import { render, staticRenderFns } from "./TextImage.vue?vue&type=template&id=6a1c3648&"
import script from "./TextImage.vue?vue&type=script&lang=js&"
export * from "./TextImage.vue?vue&type=script&lang=js&"
import style0 from "./TextImage.vue?vue&type=style&index=0&id=6a1c3648&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports